import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneThingsToDo } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiDollarSign } from "react-icons/fi";
import { FaCompass } from "react-icons/fa";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const thingsToDo: any = getOneThingsToDo();

  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const things_to_do_id = thingsToDo?.things_to_do_id;
  const [title, setTitle] = useState<any>(thingsToDo?.title || "");
  const [thumbnail, setThumbnail] = useState<any>(thingsToDo?.thumbnail || "");
  const [thumbnailId, setThumbnailId] = useState<any>(
    thingsToDo?.image_cdn_id || ""
  );

  const [email, setEmail] = useState<any>(thingsToDo?.email_address || "");
  const [payLink, setPayLink] = useState<any>(thingsToDo?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(
    thingsToDo?.phone_number || ""
  );
  const [whatsapp, setWhatsapp] = useState<any>(thingsToDo?.whatsapp || "");
  const [facebook, setFacebook] = useState<any>(thingsToDo?.facebook || "");
  const [twitter, setTwitter] = useState<any>(thingsToDo?.twitter || "");
  const [instagram, setInstagram] = useState<any>(thingsToDo?.instagram || "");
  const [youtube, setYoutube] = useState<any>(thingsToDo?.youtube || "");
  const [hashtags, setHashtags] = useState<any>(thingsToDo?.hashtag || "");

  const [googleMapCode, setGoogleMapCode] = useState<any>(
    thingsToDo?.google_map_code || ""
  );
  const [latitude, setLatitude] = useState<any>(thingsToDo?.latitude || "");
  const [longitude, setLongitude] = useState<any>(thingsToDo?.longitude || "");
  const [formattedAddress, setFormattedAddress] = useState<any>(
    thingsToDo?.formatted_address || ""
  );

  const [featured, setFeatured] = useState<any>(thingsToDo?.featured ?? "no");
  const [promoted, setPromoted] = useState<any>(
    thingsToDo?.promoted ? thingsToDo?.promoted : "no"
  );
  const [thingsToDoStatus, setThingsToDoStatus] = useState<any>(
    thingsToDo?.status ?? 1
  );
  const [expo, setExpo] = useState<any>(thingsToDo?.expo ?? 0);

  const [description, setDescription] = useState<any>(thingsToDo?.description || "");
  const [pricing, setPricing] = useState<any>(thingsToDo?.Pricings || []);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const thingsToDoRoutes = "/data/things/todo";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const safeSlug = (t: any) =>
    t ? t.toLowerCase().trim().replace(/\s+/g, "_") : null;

  const updateOneThingsToDoHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) return responses(true, "Image Required");
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : thingsToDo?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,

      title,
      slug: safeSlug(title),
      description,

      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",

      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,

      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: hashtags,

      audio_adv: "none",

      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress,
      country_short: "none",

      status: thingsToDoStatus,
      featured,
      promoted,
      expo,

      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: things_to_do_id,
      data,
      content: _TYPES_.THINGSTODO,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(false);
    setSuccess(false);
  };

  return (
    <AddPageShell
      backRoute={thingsToDoRoutes}
      eyebrow="DoSee Data • Things To Do"
      title="Edit Things To Do"
      subtitle={`Update an activity in ${entry_label || "this destination"}.`}
      icon={<FaCompass className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneThingsToDoHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A photo that captures the activity."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.THINGS_TO_DO)}
        />
      </AddSection>

      <AddSection title="Things To Do Details" hint="Title and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="thingsToDo_status"
        setStatus={setThingsToDoStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={thingsToDoStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
